module.exports = __webpack_public_path__ + "static/media/Character2.a95dbb7c.png";